import { createHashRouter } from 'react-router-dom';
import { ProtectedRoute, PublicRoute } from '@repo/auth';
import { DashboardLayout, NotFound, ErrorPage, ProfilePage } from '@repo/ui';
import { navItems } from './navigation';
import LoginPage from '@/pages/LoginPage';
import SchedulePage from '@/pages/schedule/SchedulePage';
import PaymentsPage from '@/pages/payments/PaymentsPage';
import InvoiceDetailPage from '@/pages/payments/InvoiceDetailPage';
import BillDetailPage from '@/pages/payments/BillDetailPage';
import TicketsPage from '@/pages/tickets/TicketsPage';
import AttendancePage from '@/pages/attendance/AttendancePage';
import SessionsPage from '@/pages/sessions/SessionsPage';
import GroupDetailsPage from '@/pages/groups/GroupDetailsPage';
import GroupsPage from '@/pages/groups/GroupsPage';
import DashboardPage from '@/pages/DashboardPage';
import VerifyBillPage from '@/pages/payments/VerifyBillPage';
import ReferralRewardsPage from '@/pages/referrals/ReferralRewardsPage';

export const routes = createHashRouter([
  {
    path: '/verify/bill/:billNumber',
    element: <VerifyBillPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/login',
    element: (
      <PublicRoute>
        <LoginPage />
      </PublicRoute>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <DashboardLayout navItems={navItems} headerTitle="student.auth.portalName" />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: '/groups',
        element: <GroupsPage />,
      },
      {
        path: '/groups/:id',
        element: <GroupDetailsPage />,
      },
      {
        path: '/sessions',
        element: <SessionsPage />,
      },
      {
        path: '/attendance',
        element: <AttendancePage />,
      },
      {
        path: '/tickets',
        element: <TicketsPage />,
      },
      {
        path: '/payments',
        element: <PaymentsPage />,
      },
      {
        path: '/referrals',
        element: <ReferralRewardsPage />,
      },
      {
        path: '/payments/:orderNumber',
        element: <InvoiceDetailPage />,
      },
      {
        path: '/payments/:orderNumber/bills/:billNumber',
        element: <BillDetailPage />,
      },
      {
        path: '/schedule',
        element: <SchedulePage />,
      },
      {
        path: '/profile',
        element: <ProfilePage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);
